var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column",attrs:{"id":"app"}},[_c('Navigation'),_c('mdb-scrollbar',[_c('div',{staticClass:"d-flex flex-column scroll-content"},[_c('Heading'),_c('router-view'),_c('PageFooter')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }